import { ThemeColorVariable } from '@caspeco/casper-ui-library.base-ui.theme';
export function getVisualStateStyle(visualState) {
    switch (visualState) {
        case 'success':
            return {
                borderColor: ThemeColorVariable.Success,
                boxShadow: `0 0 0 4px ${ThemeColorVariable.SuccessContainer}`,
                _hover: {
                    borderColor: ThemeColorVariable.Success,
                },
            };
        case 'warning':
            return {
                borderColor: ThemeColorVariable.Warning,
                boxShadow: `0 0 0 4px ${ThemeColorVariable.WarningContainer}`,
                _hover: {
                    borderColor: ThemeColorVariable.Warning,
                },
            };
        default:
            return undefined;
    }
}
//# sourceMappingURL=input.helper.js.map